import { MilestoneKey, BadgeStatus as Status } from "./enums/Status";

export const compassLightGreen = "#20e290";
export const compassLightGreenBackground = "#CFFFEB";
export const errorRed = "#bc2524";
export const greyText = "#8b909a";
export const lightGreenBackground = "#20e2901a";
export const lightGreyText = "#a0aec0";
export const darkGreen = "#153230";
export const lightGreyOutline = "#e2e8f0";
export const brightRed = "#EE534F";
export const compassLightRed = "#DD11551A";
export const compassBordeaux = "#DD1155";
export const compassYellow = "#FFC600";
export const compassYellowBackground = "#FFF6D9";
export const compassPaleGreen = "#A5FFD6";
export const compassOrange = "#FFA290";
export const compassLightGreyBackground = "#f2f4f7";
export const compassGreyBackground = "#e1e4e8";
export const compassDarBlue = "#3B4C66";
export const compassLightBlue = "#0F60FF";
export const blueText = "#4B88FF";
export const lightBlueBackground = "#def3f9";
export const lightBlueText = "#6bbbd3";

export const votingAlignmentBarsPalette = [compassLightGreen, "#FD7D96"];

export const tableStyles = {
  colors: {
    border: "#f2f0fe",
  },
};

export const lightGreys = {
  borderLightGrey: "#E2E8F0",
  KPIBackground: "#F8F9FA",
  loadingBg: "#D3D3D3",
};

export const graphPalette = [
  "#0B759D",
  "#20E290",
  "#9A9CEA",
  "#FD7D96",
  "#A2DCEE",
  "#A5FFD6",
  "#E9E7FD",
  "#DAEAF6",
  "#DDEDEA",
  "#51B2CF",
  "#7EC4CF",
];

export const graphPaletteV2 = [
  ...["#0B759D", "#BBEEED", "#74B8EF", compassLightGreen],
  ...graphPalette.slice(2, graphPalette.length - 1),
];

export const statusBadgeColors: Record<Status, { bg: string; text: string }> = {
  [Status.PLANNED]: { bg: "#f2f4f7", text: "#929395" },
  [Status.IN_PROGRESS]: { bg: lightBlueBackground, text: "#6bbbd3" },
  [Status.COMPLETE]: { bg: "#DDF6E8", text: "#55D38D" },
  [Status.WARNING]: { bg: compassYellowBackground, text: compassYellow },
  [Status.STUCK]: { bg: compassLightRed, text: compassBordeaux },
};

export const engagementBannerColors = [
  { bg: "#DDF6E8", text: "#55D38D" },
  { bg: lightBlueBackground, text: "#6bbbd3" },
  { bg: "#f2f4f7", text: "#929395" },
];

export const milestoneTagsColors = {
  [MilestoneKey.M1]: { bg: graphPaletteV2[0], text: "white" },
  [MilestoneKey.M2]: { bg: graphPaletteV2[1], text: graphPaletteV2[0] },
  [MilestoneKey.M3]: { bg: graphPaletteV2[2], text: "white" },
  [MilestoneKey.M4]: { bg: graphPaletteV2[3], text: "white" },
  [MilestoneKey.CI]: { bg: graphPaletteV2[4], text: "white" },
};

export const TABLE_BASE_HEIGHT = "475px";

// Escalation level colors
export const ESCALATION_COLORS: Record<number, string> = {
  1: "#fff3d9",
  2: "#FFDD8C",
  3: "#F8CBAC",
  4: "#FFA290",
  5: "#FF917B",
};

// AI gradient colors
export const AI_GRADIENT =
  "linear-gradient(135deg, #6ef2a6 0%, #32e0c4 35%, #2bb3f3 65%, #3a5cf5 100%)";

// Report gradient colors
export const REPORT_GRADIENT =
  "linear-gradient(135deg, #20E290 0%, #0B759D 25%, #9A9CEA 50%, #A2DCEE 75%, #FD7D96 100%)";

// Card gradient palette (for cycling through cards)
export const CARD_GRADIENT_PALETTE = [
  "#20E290", // compassLightGreen
  "#0B759D", // graphPalette[0]
  "#9A9CEA", // graphPalette[2]
  "#A2DCEE", // graphPalette[4]
  "#FD7D96", // graphPalette[3]
];

// Validation error type tag colors
export const validationErrorTypeColors = {
  bg: compassLightRed,
  text: compassBordeaux,
};

export const ANTD_THEME = {
  token: {
    colorPrimary: compassLightGreen,
    fontFamily: "Apercu",
    colorText: darkGreen,
  },
  components: {
    Tooltip: {
      colorBgSpotlight: "white",
      colorTextLightSolid: darkGreen,
    },
    Table: {
      // Force table to not show persistent scrollbar
      colorFillAlter: "transparent",
    },
  },
};
